import request from "@/axios/index";
export function dictFind() {
  return request({
    url: "/dataDic/selectAll",
    method: "get",
  });
}
 
// 获取邮件列表
export function getEmailList(params) {
  return request({
      url: '/sys/user/queryEmailList',
      method: 'GET',
      params
  })
}

// 按照月、季度、年度销售额&利润额显示客户的增长率图表
export function getCustomerChart(params) {
  return request({
    url: '/homeConfig/growthRateListCust',
    method: 'GET',
    params
  })
}

// 按照月、季度、年度销售额&利润额显示地域的增长率图表
export function getAreaChart(params) {
  return request({
    url: '/homeConfig/growthRateListArea',
    method: 'GET',
    params
  })
}

// 按照月、季度、年度销售额&利润额显示产品的增长率图表
export function getProChart(params) {
  return request({
    url: '/homeConfig/growthRateListPort',
    method: 'GET',
    params
  })
}

// 按照月、季度、年度销售额&利润额显示业务员的增长率图表
export function getOperChart(params) {
  return request({
    url: '/homeConfig/growthRateListOperator',
    method: 'GET',
    params
  })
}
